export const NativeEventEmitter: any = {}